/**
 * Período comercial EXTK para pagamentos: mês calendário (dia 1 até o último dia do mês).
 * O dia 31 pertence ao mesmo mês; se o mês não tiver 31 dias, o fim é o último dia daquele mês.
 */

const pad2 = (n) => String(n).padStart(2, '0');

/**
 * @param {number} mes 1-12
 * @param {number} ano
 * @returns {{ inicio: string, fim: string }} datas ISO YYYY-MM-DD
 */
export function getPeriodoComercialExtk(mes, ano) {
  const lastDay = new Date(ano, mes, 0).getDate();
  const inicio = `${ano}-${pad2(mes)}-01`;
  const fim = `${ano}-${pad2(mes)}-${pad2(lastDay)}`;
  return { inicio, fim };
}

/**
 * @param {string|null|undefined} isoDateStr YYYY-MM-DD
 * @param {number} mes referência 1-12
 * @param {number} ano
 */
export function dataIsoEstaNoPeriodo(isoDateStr, mes, ano) {
  if (!isoDateStr || typeof isoDateStr !== 'string') return false;
  const day = isoDateStr.slice(0, 10);
  const { inicio, fim } = getPeriodoComercialExtk(mes, ano);
  return day >= inicio && day <= fim;
}
